class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    new Swiper('.pickup-swiper', {
      slidesPerView: 1.4,
      centeredSlides: true,
      spaceBetween: 20,
      pagination: {
        el: '.pickup-swiper .swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
          loop: true,
        },
      }
    });

    new Swiper('.voice-swiper', {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: '.voice-swiper-wrapper .swiper-next',
        prevEl: '.voice-swiper-wrapper .swiper-prev',
      },
      pagination: {
        el: '.voice-swiper-wrapper .swiper-pagination',
        type: 'progressbar',
      },
      breakpoints: {
        // Tailwindの'sp': max 767px, 'pc': 768px以上
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }
    });

    $('.professors-swiper-wrapper').each(function(){
      var $wrapper = $(this);
      var $swiperContainer = $wrapper.find('.professors-swiper').get(0);

      // jQuery objectsをそのまま渡すとエラーになるので、セレクタ文字列かElementを使う
      new Swiper($swiperContainer, {
        slidesPerView: 1.5,
        spaceBetween: 15,
        navigation: {
          nextEl: $wrapper.find('.swiper-next').get(0),
          prevEl: $wrapper.find('.swiper-prev').get(0),
        },
        pagination: {
          el: $wrapper.find('.swiper-pagination').get(0),
          type: 'progressbar',
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }
      });
    });
    
    $('.js-news-close').on('click', function(){
      $(this).parent().fadeOut(300);
    });

    $('.js-news-cat a').on('click', function(e){
      e.preventDefault();
      $(this).addClass('is-active').siblings().removeClass('is-active');
      $('.js-news-list > div').eq($(this).index()).fadeIn().siblings().hide();
    });

    
    if (window.matchMedia('(max-width: 767px)').matches) {
      $('.js-professors-list:nth-of-type(n+2)').hide();
      $('.js-professors-trigger a').on('click', function(e){
        e.preventDefault();
        $(this).addClass('is-active').siblings().removeClass('is-active');
        $('.js-professors-list').eq($(this).index()).fadeIn().siblings('.js-professors-list').hide();
      });
    }
  }
}
